// Game-module shim (unify Phase 3): resolves to the active game's DraftContext.
import game from '../games';
const impl = game.id === 'mlbb'
  ? require('../games/mlbb/contexts/DraftContext')
  : require('../games/dota/contexts/DraftContext');
export const DraftProvider = impl.DraftProvider;
export const useDraft = impl.useDraft;
// MAP_OPTIONS only exists for games with per-map drafts (MLBB); undefined otherwise.
export const MAP_OPTIONS = impl.MAP_OPTIONS;
